import { render } from "./MainCategories.vue?vue&type=template&id=7cd9504e&scoped=true&ts=true"
import script from "./MainCategories.vue?vue&type=script&lang=ts"
export * from "./MainCategories.vue?vue&type=script&lang=ts"

import "./MainCategories.vue?vue&type=style&index=0&id=7cd9504e&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cd9504e"]])

export default __exports__